<p-confirmDialog key="portalappimport" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="portalappimportconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="InstructionDiv">
	<h4>Instructions:</h4>

	<div class="InstructionDetailsDiv">
		<p>Start by importing a list of people to register. If you don't have one, press Export and select the students or staff members</p>
		<p>
			Press Import to import the list. The required columns are <span style="font-weight: bold">ID (Student or Staff)</span> and
			<span style="font-weight: bold">Email (Parent, Staff, or Student)</span>
		</p>
		<p>You will be asked to pick what the columns represent (they can be in any order in the file)</p>
		<p>After importing the file the table will get filled in. Double check your data and fill in any missing email addresses</p>
		<p>NOTE: When the data loads some entries might be marked as invalid if the ID is incorrect.</p>
		<p>When you are finished filling out the table press Batch Email to email a registration code to everyone in the table</p>
		<p>When users download the Parent, Student, or Staff Portal app they will be asked to scan the code they receive</p>
	</div>
</div>

<!--Buttons-->
<div class="ButtonMenu">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning" (click)="onRemoveSelected()">Remove Selected</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning" (click)="onRemoveInvalid()">Remove Invalid</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning" (click)="onClearImport()">Clear Import Data</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onDownloadImport()">Download Import Table</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onExport()">Export</button>
	<button [disabled]="IsLoading() == true" class="btn btn-success" (click)="onBatchEmail()">Batch Email</button>
</div>

<!--Import List Preview-->
<div>
	<p-accordion>
		<p-accordionTab
			header="Imported Data {{ ImportPreviewExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="ImportPreviewExpand"
		>
			<div>
				<caass-portal-app-batch-import-table [TableLoading]="TableLoading"></caass-portal-app-batch-import-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Email Log Table-->
<!-- <div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab header="Email Log {{ EmailLogExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="EmailLogExpand">
			<div>
				<caass-portal-app-batch-email-log> </caass-portal-app-batch-email-log>
			</div>
		</p-accordionTab>
	</p-accordion>
</div> -->

<!--Error Message-->
<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>
